module.exports = __webpack_public_path__ + "img/container2LogoR.d0bc4624.png";